import { type CSSProperties } from 'react';

import { Typography } from '@/design-system';
import type { PipelineColumn as PipelineColumnDto } from '@/pages/pipelines/common/types';

import { getPipelineStageColor, getPipelineStageDisplayLabel } from './stage-presentation';
import { StageTab, StageTabCount, StageTabs } from './styled';

type Props = {
  columns: PipelineColumnDto[];
  expandedStage?: string;
  onSelectStage: (_stage: string) => void;
};

export const PipelineStageTabs = ({ columns, expandedStage, onSelectStage }: Props) => (
  <StageTabs aria-label="Pipeline stages">
    {columns.map((column) => {
      const stageColor = getPipelineStageColor(column);

      return (
        <StageTab
          key={column.stage}
          type="button"
          data-active={column.stage === expandedStage}
          data-terminal={column.terminal}
          style={{ '--stage-color': stageColor } as CSSProperties}
          onClick={() => onSelectStage(column.stage)}
        >
          <Typography variant="body3" color={stageColor} as="span">
            {getPipelineStageDisplayLabel(column.label)}
          </Typography>
          <StageTabCount>{column.count}</StageTabCount>
        </StageTab>
      );
    })}
  </StageTabs>
);
